import React, { useState } from "react";
import { Box, Button, Container, Grid2 as Grid, useMediaQuery, useTheme } from "@mui/material";
import Page from "src/components/Page";
import { websiteTitle } from "src/config";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import { Link as RouterLink } from "react-router-dom";
import ManageAlertsTable from "./ManageAlertsTable";
import { ChartBarBig } from "lucide-react-new";
import CreateAlertButton from "src/components/CreateAlertButton.js";

const useStyles = makeStyles()(theme => ({
    metalRoot: {
        backgroundColor: "var(--neutral-1)",
        minHeight: "100%",
        [theme.breakpoints.up("md")]: {
            padding: `0 ${theme.spacing(4)} ${theme.spacing(0.5)}`,
        },
    },
    alertsBtn: {
        color: "#e6e5e8 !important",
        fontSize: "16px",
        textTransform: "capitalize",
        borderRadius: "var(--radius-md, 8px)",
        border:
            "1px solid var(--Component-colors-Components-Buttons-Secondary-color-button-secondary-color-border, #364152)",
        background:
            "var(--Component-colors-Components-Buttons-Secondary-color-button-secondary-color-bg, #121926)",
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        whiteSpace: "nowrap",
        "&:hover": {
            textDecoration: "none !important",
        },
    },
}));

const AlertsManagementView = props => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { classes } = useStyles();
    const pageTitle = websiteTitle + " - " + t("manageAlerts");
    const largeDevice = useMediaQuery(theme.breakpoints.down("lg"));
    const mediumDevice = useMediaQuery(theme.breakpoints.down("md"));
    const smallerDevice = useMediaQuery(theme.breakpoints.down(450));

    const [update, setUpdate] = useState(false);
    const [loading, setLoading] = useState(true);
    const [noData, setNoData] = useState(true);

    return (
        <Page className={classes.metalRoot} title={pageTitle}>
            <Container maxWidth="xxl">
                <header
                    className="m-heading has-space-m"
                    style={
                        largeDevice
                            ? {
                                  padding: "0 0 16px 0",
                                  position: "relative",
                              }
                            : {
                                  padding: "var(--space-xxl) 0 16px 0",
                                  position: "absolute",
                                  top: "18px",
                                  right: "58px",
                              }
                    }
                >
                    <div
                        className="m-stack"
                        style={mediumDevice ? { minHeight: "40px" } : { height: "40px" }}
                    >
                        <div
                            style={
                                mediumDevice
                                    ? {
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "flex-start",
                                          justifyContent: "flex-start",
                                      }
                                    : {
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                      }
                            }
                        >
                            <div style={{ flex: 1 }}></div>
                            {!noData && (
                                <div
                                    style={
                                        mediumDevice
                                            ? {
                                                  display: "flex",
                                                  flexDirection: smallerDevice ? "column" : "row",
                                                  justifyContent: "space-between",
                                                  alignItems: smallerDevice
                                                      ? "flex-start"
                                                      : "center",
                                                  marginTop: "32px",
                                              }
                                            : {}
                                    }
                                >
                                    <Button
                                        style={smallerDevice ? { marginTop: "8px" } : {}}
                                        className={classes.alertsBtn}
                                        component={RouterLink}
                                        variant="outlined"
                                        to="/app/alerts/active"
                                        startIcon={<ChartBarBig />}
                                    >
                                        {t("viewAlerts")}
                                    </Button>
                                    <CreateAlertButton
                                        buttonStyle={
                                            smallerDevice
                                                ? {
                                                      marginLeft: 0,
                                                      marginTop: 16,
                                                  }
                                                : {}
                                        }
                                        update={update}
                                        setUpdate={setUpdate}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </header>
                <Box
                    mt={mediumDevice ? 0 : 4}
                    flexDirection="column"
                    justifyItems="center"
                    alignItems="center"
                >
                    <Grid justifyContent="center" size={12} style={{ width: "100%" }}>
                        <ManageAlertsTable
                            {...props}
                            setNoData={setNoData}
                            update={update}
                            setUpdate={setUpdate}
                            loading={loading}
                            setLoading={setLoading}
                        />
                    </Grid>
                </Box>
            </Container>
        </Page>
    );
};

export default AlertsManagementView;
